import request from "@/utils/request";

// 分页查询
export function queryCustomFormTable(data) {
  return request({
    url: "/form/page",
    method: "post",
    data,
  });
}

// 根据id查询详情
export function queryCustomFormById(id) {
  return request({
    url: `/form/${id}`,
    method: "get",
  });
}

// 新增
export function insertCustomForm(data) {
  return request({
    url: "/form/save",
    method: "post",
    data,
  });
}

// 修改
export function updateCustomForm(data) {
  return request({
    url: "/form/update",
    method: "post",
    data,
  });
}

// 删除
export function deleteCustomFormById(id) {
  return request({
    url: `/form/delete/${id}`,
    method: "delete",
  });
}
